<template>
  <div class="market-container">
    <div class="container-responsive">
      <div class="row pb-20">
        <p class="heading">Marketplace</p>
        <div class="align-right col-md-7 col-lg-4 col-sm-7 col-xs-12">
          <p class="pr-8 mt-10">Service Type</p>
          <multiselect
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
            class="multiselect-dropdown multiselect-single-dropdown"
            :searchable="false"
            :options="servicesList"
            placeholder="Select Service"
            v-model="selectedService"
            @change="filterServices"
          >
            <span slot="noResult">No matching data</span>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="filterServices && filterServices.length">
        <div class="service-title">RAMS Services</div>
        <br />
        <div
          class="service-card col-lg-3 col-md-4 col-sm-6 col-xs-12 pr-30 pl-0"
          v-for="(service, index) in filterServices"
          :key="index"
        >
          <div class="offer-content" v-if="service.id === 1 || service.id === 4">
            <template
              v-if="!service.alreadyAdded && !service.trialEnded && !service.renewedService"
            >
              <img
                class="rectangle-icon emergo-rec-green"
                src="/static/images/icons/rectangle_banner.svg"
                alt="rectangle-icon"
              />
              <p class="free-text free-trial-text">Free Trial</p>
            </template>
          </div>
          <div
            class="offer-content"
            v-if="
              service.id === 10 && todayDate() > renewStartDate() && todayDate() < renewEndDate()
            "
          >
            <img
              class="rectangle-icon emergo-rec-blue"
              src="/static/images/icons/rectangle_banner.svg"
              alt="rectangle-icon"
            />
            <p class="free-text free-text-pc">OFFER</p>
          </div>
          <div class="market-card p-0">
            <div class="inner-card">
              <div class="market-heading">
                <img
                  class="market-img mb-16"
                  :src="getBlobUrl(service.icon_location)"
                  alt="service-icon"
                />
                <p class="card-title mb-16">{{ service.name }}</p>
                <div class="details-text mb-16" v-html="service.description"></div>
                <p class="learn-more" @click="learnMore(service.id, service.name)">Learn More</p>
              </div>
              <div
                v-if="
                  (service.expiry_date || service.alreadyAdded) &&
                  ((service.id !== 6 && service.alreadyAdded) ||
                    (service.id === 6 && service.alreadyAdded && isProdClassServiceActive))
                "
                class="row"
              >
                <hr class="separator" />
                <div class="status">
                  <template v-if="service.expiry_date">
                    <img src="/static/images/icons/expiring_soon.svg" alt="expiring soon" />
                    <span>Expires on {{ service.expiry_date | UTCDate('DD MMM YYYY') }}</span>
                  </template>
                  <template v-else-if="service.alreadyAdded">
                    <img
                      class="check-icon"
                      src="/static/images/icons/check_icon.svg"
                      alt="active"
                    />
                    <span>Active</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="otherServices && otherServices.length">
        <div class="service-title">Affiliate SaaS Services</div>
        <br />
        <div
          class="service-card col-lg-3 col-md-4 col-sm-6 col-xs-12 pr-30 pl-0"
          v-for="(service, index) in otherServices"
          :key="index"
        >
          <div class="offer-content" v-if="service.id == 5">
            <img
              class="rectangle-icon emergo-rec-blue"
              src="/static/images/icons/rectangle_banner.svg"
              alt="rectangle-icon"
            />
            <p class="free-text free-text-gg">PARTNER</p>
          </div>
          <div class="offer-content" v-if="service.id == 8">
            <img
              class="rectangle-icon emergo-rec-blue"
              src="/static/images/icons/rectangle_banner.svg"
              alt="rectangle-icon"
            />
            <p class="free-text">UL LMS</p>
          </div>
          <div class="offer-content" v-if="service.id == 9">
            <img
              class="rectangle-icon emergo-rec-blue"
              src="/static/images/icons/rectangle_banner.svg"
              alt="rectangle-icon"
            />
            <p class="free-text free-text-opus">EMERGO</p>
          </div>
          <div class="market-card p-0">
            <div class="inner-card">
              <div class="market-heading">
                <img
                  class="market-img mb-16 width-23"
                  :class="{ 'icon-opus': service.id === 9 }"
                  :src="getBlobUrl(service.icon_location)"
                  alt="service-icon"
                />
                <p class="card-title mb-16">{{ service.name }}</p>
                <div class="details-text mb-16" v-html="service.description"></div>
                <p class="learn-more" @click="learnMore(service.id, service.name)">Learn More</p>
              </div>
              <!-- <div>
              <hr class="separator-other">
              <div class="other-status">
                <template>
                  <span class="cursor-pointer" v-if="service.id === 8 || service.id === 9" @click="redirectService(service.id)">Contact Us</span>
                  <span class="cursor-pointer" v-if="service.id === 5" @click="redirectService(service.id)">Request Information</span>
                </template>
              </div>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import { sortBy } from 'lodash';
import CloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { getServiceDesc } from '../../apis/marketPlace';
import { getPlans, getMapping, getActivePlansList } from '../../apis/plans';
import { getExpiryServices } from '../../apis/notification';
import { getRenewedServices } from '../../apis/psm';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import { getActiveProdClassCount } from '../../apis/prodClassification';

export default {
  props: ['account_id', 'account_type_id'],
  data() {
    return {
      activeProdClassCount: 0,
      loaderStatus: false,
      services: [],
      addedServices: [],
      allPlans: [],
      expiryServices: [],
      servicesList: [],
      selectedService: 'All Services',
      activeServices: {}
    };
  },
  components: { Loader },
  methods: {
    getBlobUrl(filePath, tokenRequired) {
      if (filePath) {
        if (tokenRequired) {
          return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}${this.sasToken}`;
        }
        return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}`;
      }
      return null;
    },
    async getServiceDesc() {
      this.loaderStatus = true;
      const services = await getServiceDesc();
      this.allPlans = await getPlans();
      const planMap = await getMapping();
      this.activeServices = await getActivePlansList(this.account_id);
      const expiryServices = await getExpiryServices(this.account_id);
      const loopService = CloneDeep(services);
      this.allPlans.forEach((plan) => {
        const planServices = planMap.find((each) => each.plan_id === plan.id);
        if (this.activeServices.active_plans.find((activePlan) => activePlan.id === plan.id)) {
          loopService.forEach((service, index) => {
            if (planServices.service_id.includes(service.id)) {
              services[index].alreadyAdded = true;
            }
          });
        } else if (
          this.activeServices.trail_ended_plans.find((activePlan) => activePlan === plan.id)
        ) {
          loopService.forEach((service, index) => {
            if (planServices.service_id.includes(service.id)) {
              services[index].trialEnded = true;
            }
          });
        }
        if (expiryServices && expiryServices.data && expiryServices.data.plan) {
          if (expiryServices.data.plan.find((activePlan) => activePlan.id === plan.id)) {
            loopService.forEach((service, index) => {
              if (planServices.service_id.includes(service.id)) {
                services[index].expiry_date = expiryServices.data.plan.find(
                  (activePlan) => activePlan.id === plan.id
                ).expiry_date;
              }
            });
          }
        }
      });
      // if (expiryServices.data.plan) {
      //   this.expiryServices = expiryServices.data.plan;
      //   loopService.forEach((service, index) => {
      //     const response = this.expiryServices.find((o) => o.id === service.id);
      //     if (response) {
      //       services[index].expiry_date = response.expiry_date;
      //     }
      //   });
      // }
      const renewedServices = await getRenewedServices(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      if (renewedServices.data.plan) {
        loopService.forEach((service, index) => {
          const response = renewedServices.data.plan.find(
            (o) => o === service.id || o === 13 || o === 14
          );
          if (
            response &&
            (service.id === 1 ||
              service.id === 2 ||
              service.id === 4 ||
              service.id === 6 ||
              service.id === 7 ||
              service.id === 10)
          ) {
            services[index].renewedService = true;
          }
        });
      }
      const userData = JSON.parse(localStorage.getItem('userData'));
      for (let i = services.length - 1; i >= 0; ) {
        if (
          userData.account_type_id === 2 &&
          (services[i].name === 'Regulatory Watch' ||
            services[i].name === 'Registration Tracker' ||
            services[i].name === 'Regulatory Intelligence')
        ) {
          delete services[i].expiry_date;
        }
        i -= 1;
      }
      if (userData.account_type_id === 2) {
        this.services = sortBy(
          services.filter((s) => s.id !== 10),
          'sequence'
        );
      } else this.services = sortBy(services, 'sequence');
      this.$forceUpdate();
      this.loaderStatus = false;
    },
    learnMore(id, name) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: `Learn More Click`,
        ServiceName: name
      });
      if (id === 9) {
        window.open('https://www.emergobyul.com/opus', '_blank');
      } else {
        this.$router.push({ path: `/layout/market-place/service/${id}` });
        EventBus.$emit('activeMenuTitle', this.$route.name);
      }
    },
    redirectService(id) {
      if (id === 5) {
        window.open('https://www.greenlight.guru/emergopartners', '_blank');
      } else if (id === 8) {
        window.open(
          'https://www.ul.com/contact-sales/c1218e9b-099b-4c21-ad18-10ae0700b939/183836/?utm_source=emergo&utm_medium=referral&utm_campaign=rams_cw&utm_term=lhs&utm_content=contact',
          '_blank'
        );
      } else if (id === 9) {
        window.location.assign('mailto:opushelp@ul.com');
      }
    },
    todayDate() {
      return moment().utc().format('YYYY-MM-DD HH:mm:ss');
    },
    renewStartDate() {
      return moment.utc('06/01/2022').format('YYYY-MM-DD HH:mm:ss');
    },
    renewEndDate() {
      return moment.utc('10/01/2022').format('YYYY-MM-DD HH:mm:ss');
    }
  },
  created() {
    this.servicesList = ['All Services', 'Active Services', 'RAMS Services', 'Partner Services'];
    this.getServiceDesc();
  },
  filters: {
    UTCDate(date, format) {
      return date ? moment.utc(date).format(format) : '';
    }
  },
  async mounted() {
    this.activeProdClassCount = await getActiveProdClassCount(
      JSON.parse(localStorage.getItem('userData')).account_id
    );
  },
  computed: {
    isProdClassServiceActive() {
      let showFlag = true;
      if (
        this.activeServices &&
        this.activeServices.active_plans &&
        this.activeServices.active_plans.length > 0
      ) {
        const planProd = this.activeServices.active_plans.filter((element) => element.id === 7);
        if (
          planProd &&
          planProd.length > 0 &&
          planProd[0].service_type === 'trial' &&
          this.activeProdClassCount > 0
        ) {
          showFlag = false;
        } else showFlag = true;
      }
      return showFlag;
    },
    filterServices() {
      let filteredServices = [];
      if (this.selectedService === 'RAMS Services') {
        filteredServices = this.services.filter(
          (service) => !(service.id === 5 || service.id === 8 || service.id === 9)
        );
      }
      if (this.selectedService === 'Partner Services') {
        filteredServices = [];
      }
      if (this.selectedService === 'Active Services') {
        filteredServices = this.services.filter((service) => service.alreadyAdded);
      }
      if (this.selectedService === 'All Services') {
        filteredServices = this.services.filter(
          (service) => service.id !== 5 && service.id !== 8 && service.id !== 9
        );
      }
      return filteredServices;
    },
    otherServices() {
      let otherServices = [];
      if (this.selectedService === 'RAMS Services') {
        otherServices = [];
      }
      if (this.selectedService === 'Partner Services') {
        otherServices = this.services.filter(
          (service) => service.id === 5 || service.id === 8 || service.id === 9
        );
      }
      if (this.selectedService === 'Active Services') {
        otherServices = [];
      }
      if (this.selectedService === 'All Services') {
        otherServices = this.services.filter(
          (service) => service.id === 5 || service.id === 8 || service.id === 9
        );
      }
      return otherServices;
    }
  }
};
</script>
<style scoped>
.align-right {
  display: flex;
  align-items: center;
  float: right;
  margin-right: 16px;
}
.align-right > p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.service-title {
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  color: rgba(0, 0, 0, 0.7);
}
.multiselect-dropdown {
  flex: 1;
}
.service-card {
  position: relative;
}
.market-container {
  margin: 20px 40px;
}

.pr-8 {
  padding-right: 8px;
}
.pb-20 {
  padding-bottom: 20px;
}
.heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
  float: left;
}
.p-0 {
  padding: 0px;
}
.pr-30 {
  padding-right: 30px;
}

.mb-16 {
  margin-bottom: 16px;
}
.market-card {
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  margin-bottom: 30px;
  padding-bottom: 8px;
}

.inner-card {
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 11px;
  color: #174c76;
  height: 385px;
  padding: 24px;
}
.market-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.card-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  color: #0b3c61;
  height: 50px;
  display: flex;
  text-align: center;
}
.details {
  min-height: 160px;
  position: relative;
  padding: 10px;
}
.details-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  height: 136px;
  overflow-y: hidden;
}
.details-text:hover {
  overflow-y: auto;
  scrollbar-width: thin;
}
.pl-0 {
  padding-left: 0px;
}

.learn-more {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #2f80ed;
  cursor: pointer;
  margin-bottom: 16px;
}

.separator {
  margin: 0 16px 16px;
}
.separator-other {
  margin: 0 0px 16px;
}
.status {
  display: flex;
  justify-content: center;
  align-items: center;
}
.status > img {
  margin: 0 6px;
}
.status > span {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
.other-status {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #0b3c61;
}
.check-icon {
  width: 18px;
  background: green;
  padding: 4px;
  border-radius: 50px;
  height: 18px;
}
.emergo-rec-green {
  filter: invert(45%) sepia(74%) saturate(390%) hue-rotate(68deg) brightness(101%) contrast(83%);
}
.emergo-rec-blue {
  filter: invert(15%) sepia(98%) saturate(3090%) hue-rotate(190deg) brightness(91%) contrast(102%);
}
.emergo-rec-teal {
  filter: invert(30%) sepia(20%) saturate(6522%) hue-rotate(162deg) brightness(91%) contrast(104%);
}
.emergo-rec {
  filter: invert(15%) sepia(22%) saturate(5184%) hue-rotate(185deg) brightness(99%) contrast(92%);
}
.emergo-rec-light-blue {
  filter: invert(44%) sepia(36%) saturate(4074%) hue-rotate(199deg) brightness(96%) contrast(93%);
}
.rectangle-icon {
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  transform: rotate(269.7deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(360deg);
  -ms-transform: rotate(269.7deg);
  -o-transform: rotate(269.7deg);
  width: 105px;
  height: 90px;
}
.free-text {
  position: absolute;
  z-index: 1;
  left: 12px;
  top: 24px;
  -webkit-transform: rotate(312deg);
  -moz-transform: rotate(312deg);
  -ms-transform: rotate(312deg);
  -o-transform: rotate(312deg);
  transform: rotate(312deg);
  font-weight: bold;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #ffffff;
  padding: 0;
  text-align: center;
  transform: rotate(-40deg);
}
.free-text-pc {
  left: 14px;
  top: 24px;
}
.free-text-gg {
  left: 4px;
}
.free-text-opus {
  left: 8px;
  top: 23px;
}
.offer-text {
  position: absolute;
  z-index: 1;
  top: 47px;
  left: -8px;
  -webkit-transform: rotate(312deg);
  -moz-transform: rotate(312deg);
  -ms-transform: rotate(312deg);
  -o-transform: rotate(312deg);
  transform: rotate(312deg);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;
  padding: 0;
}
.offer-text-gg {
  top: 48px !important;
  left: 29px !important;
}
.title {
  font-size: 18px;
  margin: 5px;
  font-weight: 100;
  color: #ffffff;
}
.traingle-alert {
  width: 17px;
  margin-right: 10px;
  vertical-align: top;
}

.market-img {
  height: 40px;
  width: 40px;
}

.icon-opus {
  width: 100px !important;
  height: 50px !important;
  margin-bottom: 6px !important;
}
@media only screen and (max-width: 414px) {
  .details {
    margin-bottom: 20px;
  }
  .pr-30 {
    padding-right: 0px;
  }

  .align-right {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media screen and (min-width: 2304px) {
  .width-23 {
    width: 70px;
  }
}
@media (min-width: 1400px) and (max-width: 1900px) {
  .market-img {
    width: 70px;
  }
  .width-23 {
    width: 60px;
  }
}
@media screen and (max-width: 767px) {
  .check-icon {
    right: 45px;
  }
  .expiry-body {
    width: 70%;
  }

  .align-right {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (min-width: 993px) and (max-width: 1399px) {
  .rectangle-icon {
    width: 106px;
    left: 0px;
  }
  .offer-text {
    top: 45px;
    left: -12px;
  }
  .free-text-pc {
    left: 26px;
    top: 24px;
  }
  .offer-text-gg {
    top: 43px !important;
    left: 26px !important;
  }
  .free-text-gg {
    left: 4px;
  }
  .expiry-body {
    width: 70%;
    height: 25px;
  }
  .title {
    font-size: 13px;
    margin: 5px;
  }
  .traingle-alert {
    width: 13px;
  }
  .extra-width {
    width: 82px;
  }
  .width-23 {
    width: 70px;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .width-23 {
    width: 70px;
  }
  .expiry-body {
    width: 75%;
    height: 35px;
  }
  .title {
    font-size: 20px;
    margin: 6px;
  }
  .traingle-alert {
    width: 20px;
  }
}
@media screen and (max-width: 576px) {
  .check-icon {
    right: 45px;
  }
  .title {
    font-size: 15px;
    margin: 6px;
  }
  .traingle-alert {
    width: 15px;
  }
}
.free-trial-text {
  left: 4px;
  top: 25px;
}
</style>
